import { makeStyles } from '@mui/styles';

import { globalTheme as theme } from '@styles';

export const useStyles = makeStyles(() => ({
  root: {
    color: theme.palette.brandBlue.darker,
    textTransform: 'capitalize',
    padding: '0.5rem',
  },
}));
